import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "../../../app/axios";
import { API_URL } from "../../../app/config";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";

export const getAllAutoLeadAssigns = createAsyncThunk(
  "AssignedUser/FindAllAutoAssignEmployee",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/AssignedUser/FindAllAutoAssignEmployee`,
        { EmployeeName: "" }
      );
      // SuccessToast(response.data?.Details || "Success");
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching auto lead assign settings:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateAutoLeadAssign = createAsyncThunk(
  "AssignedUser/UpdateAutoAssignEmployee",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/AssignedUser/UpdateAutoAssignEmployee`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating auto lead assign:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const insertAutoLeadAssignSetting = createAsyncThunk(
  "AssignedUser/InsertAutoAssignEmployee",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/AssignedUser/InsertAutoAssignEmployee`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error setting auto lead assign:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteAutoLeadAssignSetting = createAsyncThunk(
  "AssignedUser/DeleteAutoAssignEmployee",
  async (ID: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/AssignedUser/DeleteAutoAssignEmployee`,
        { IDs: `${ID}` }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting auto lead assign:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getLeadAssignSettings = createAsyncThunk(
  "AssignedUser/GetLeadAutoAssignSetting",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/AssignedUser/GetLeadAutoAssignSetting`
      );
      const result = response.data?.Data as any;
      return {
        LeadAutoAssign: result?.LeadAutoAssign,
        SectorWiseAssign: result?.SectorWiseAssign,
        EmployeeID: result?.EmployeeID
          ? result?.EmployeeID?.split(",")?.map((e: any) => +e)
          : [],
        EmployeeName: result?.EmployeeName,
      } as any;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching lead assign setting:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
